import React, { useEffect, useState } from "react";
import { Modal, Button, Accordion, Card } from "react-bootstrap";
import ReactPlayer from "react-player";
import tandemStore from "../../../stores/store";

const RenderPackageInfo = ({ giftcardReservation, state, location, isGrouponRes }) => {
  const [container, setContainer] = useState(null);

    const [show, setShow] = useState(false);
    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);

    useEffect(() => {
    setContainer(document.body);
  }, []);

    if (state.loadPrices !== undefined) {
        var tandemPackages1 = state.loadPrices.tandemPackages
        .filter(
            (pkg) =>
            pkg.isBookable &&
            ((state.eventFilter !== "All" &&
                pkg.calenderEvent === state.eventFilter) ||
                state.eventFilter === "All")
        )
        .map((pkg, i) => {
            if (pkg.weekendPrice !== pkg.price) {
            return (
                <React.Fragment>
                <div className="marginBwAccordion">
                    <div>
                    <p className="right-side-info">
                        {pkg.item} weekday{" "}
                        {!giftcardReservation ? <>$ {pkg.price}</> : " "}
                    </p>
                    </div>
                    {pkg.description && pkg.description != "" && (
                    <Card.Body style={{ padding: "0px 0 10px 0" }}>
                        {pkg.description}
                    </Card.Body>
                    )}
                </div>
                <div className="marginBwAccordion">
                    <div>
                    <p className="right-side-info">
                        {pkg.item} weekend{" "}
                        {!giftcardReservation ? <>$ {pkg.weekendPrice}</> : " "}
                    </p>
                    </div>
                    {pkg.description && pkg.description != "" && (
                    <Card.Body style={{ padding: "0px 0 10px 0" }}>
                        {pkg.description}
                    </Card.Body>
                    )}
                </div>
                </React.Fragment>
            );
            } else {
            return (
                <div className="marginBwAccordion">
                <div>
                    <p className="right-side-info">
                    {pkg.item} {!giftcardReservation ? <>$ {pkg.price}</> : " "}
                    </p>
                </div>
                {pkg.description && pkg.description != "" && (
                    <Card.Body style={{ padding: "0px 0 10px 0" }}>
                    {pkg.description}
                    </Card.Body>
                )}
                </div>
            );
            }
        });
        var videoPackages = state.loadPrices.videoPackages
        .filter((pkg) => pkg.isBookable)
        .map((pkg, i) => {
            return (
            <div className="marginBwAccordion">
                <div>
                <p className="right-side-info">
                    {/* <p className="videoAdvertisement">Check Video</p> */}
                    {pkg.item}{" "}
                    {!giftcardReservation ? <>$ {pkg.videoPrice}</> : " "}
                </p>
                </div>

                {pkg.videoLink ? (
                <Card.Body style={{ padding: "0px 0 10px 0" }}>
                    <div className="videoContainer">
                    <ReactPlayer height="100%" width="100%" url={pkg.videoLink} />
                    </div>
                </Card.Body>
                ) : (
                ""
                )}

                {pkg.description ? (
                <Card.Body style={{ padding: "0px 0 10px 0" }}>
                    {pkg.description}
                </Card.Body>
                ) : (
                ""
                )}
            </div>
            );
        });
    }

    const grouponReservation = () => {
        return <Accordion>
                {videoPackages}
            </Accordion>
    }

    const regularReservation = () => {
        return             <Accordion>
        {tandemPackages1}
        {videoPackages}
        {state.loadPrices !== undefined &&
        location.pathname !== "/groupon" &&
        location.pathname !== "/rush49" &&
        !window.ENV.dontShowAFF && (
            <>
            <div>
                <div>
                {tandemStore.getFirstJump()?.type === "STP" ||
                tandemStore.getFirstJump()?.type === "ASP" ? (
                    <Accordion.Toggle
                    as={Button}
                    eventKey={tandemStore.getFirstJump()?.calenderEvent}
                    style={{ width: "100%" }}
                    >
                    {tandemStore.getFirstJump()?.name}{" "}
                    {!giftcardReservation ? (
                        <>$ {tandemStore.getFirstJump()?.price}</>
                    ) : (
                        ""
                    )}
                    </Accordion.Toggle>
                ) : (
                    tandemStore
                    .getStudentPackages()
                    .filter(
                        (pkg) =>
                        pkg.isBookable &&
                        ((state.eventFilter !== "All" &&
                            pkg.calenderEvent === state.eventFilter) ||
                            state.eventFilter === "All")
                    )
                    .map((item) => (
                        <div
                        key={item.calenderEvent}
                        className="marginBwAccordion"
                        >
                        <div>
                            <p className="right-side-info">
                            {item.calenderEvent}{" "}
                            {!giftcardReservation ? (
                                <>$ {item.price}</>
                            ) : (
                                ""
                            )}
                            </p>
                        </div>
                        {item.description && item.description !== "" && (
                            <Card.Body style={{ padding: "0px 0 10px 0" }}>
                            {item.description}
                            </Card.Body>
                        )}
                        </div>
                    ))
                )}
                </div>

                {/* Description Collapse */}
                {tandemStore.getFirstJump()?.description &&
                tandemStore.getFirstJump()?.description !== "" && (
                    <Accordion.Collapse
                    eventKey={
                        tandemStore.getFirstJump()?.type === "STP" ||
                        tandemStore.getFirstJump()?.type === "ASP"
                        ? tandemStore.getFirstJump()?.name
                        : tandemStore.getFirstJump()?.calenderEvent +
                            "" +
                            tandemStore.getFirstJump()?.price
                    }
                    >
                    <Card.Body>
                        {tandemStore.getFirstJump()?.description}
                    </Card.Body>
                    </Accordion.Collapse>
                )}
            </div>
            </>
        )}
    </Accordion>
    }

    return (
        <>
        <Modal show={show} onHide={handleClose} size="md" container={container} >
            <Modal.Header closeButton>
            <Modal.Title>Packages Information</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {isGrouponRes ? grouponReservation() : regularReservation()}
            </Modal.Body>

            <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
                Close
            </Button>
            </Modal.Footer>
        </Modal>
        <button onClick={handleShow} className="btn btn-primary-em explore-packs right" style={{marginTop:20}}>Click Here To Explore Packages and Pricing</button>
        </>
    );
};

export default RenderPackageInfo;
